import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
    getSpeciality({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/Segmented/getSpeciality`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  findAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`Segmented/findAll`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  checkYear({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`Segmented/checkYear`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
};
